'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Typography = require('../Typography.js');
var index = require('../../theme/index.js');
var Banner_module = require('./Banner.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const typeColors = {
  success: {
    color: index.colors.statusSuccessDark,
    background: index.colors.statusSuccessLight
  },
  error: {
    color: index.colors.statusDangerDark,
    background: index.colors.statusDangerLight
  }
};
const Banner = _ref => {
  let {
    type,
    children
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    role: "status",
    className: Banner_module["default"].banner,
    style: {
      background: typeColors[type].background,
      borderColor: typeColors[type].color
    }
  }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, children));
};

exports["default"] = Banner;
